import _find from 'lodash/find';
import styles from './status.module.scss';
import { KoDropdown, KoText, KoToast  } from 'packages';
import KoIcon from '@kwapio/icons';
import { ATYPE, CUSTOMER_MANAGEMNT_WORKFLOW } from 'pages/customers/customersList/constant';
import { ClientsAPI } from 'pages/customers/customers.service';


function CustomerStatus(props) {
  let { data, row, column, refreshData } = props;
  let LIST = column.dataIndex === 'type' ? ATYPE : CUSTOMER_MANAGEMNT_WORKFLOW;
  let issueType = _find(LIST, function(o) { return o.value === data; }) || {};
  const workflow = LIST.filter(item => item.value !== issueType.value);

  const statusItems = workflow?.map((sta) => ({
    label: (
      <div className={`${styles.filterList}`} onClick={() => sortTemplates(sta.value)}>
        <div className={styles.userDpWithName}>
          <div className="statusCircle" style={{ borderColor: sta.color }} />
          <KoText text={sta.label} />
        </div>
      </div>
    ),
    key: sta?.key,
    value: sta?.value
  }));
  
  const updateFields = (e) => {
    ClientsAPI.updateFileds(e, row?.customerId).then(
      (res) => {
        KoToast.success(`Customer ${column.dataIndex === 'type' ? 'Account Type' : 'Status'} updated successfully`);
        refreshData();
      }
    );
  };
  


  const sortTemplates = (key) => {
    updateFields({[column.dataIndex]: key});
  };
    
  return (
    <div className={`${styles.wrapper}`}>
      
      <KoDropdown
        placement="bottomRight"
        overlayClassName={'overlayClassName'}
        menu={{
          items:statusItems
        }}
      >
        <div className={`${styles.status}`}>
          <div className={styles.circle}  style={{borderColor: issueType?.color}}/>
          <div className={styles.text}>{issueType?.label}</div>
          <KoIcon name="DownArrowOutlined"  height={8} width={8}/>
        </div>
        
      </KoDropdown>
    </div>
  );
}
export default CustomerStatus;
